import { DailyBonusesCardItem } from 'v2/components/bonusesCards';
import { DailyRewardModel } from 'v2/types/DailyRewardModel';

export const getDailyRewardCardItems = (dailyRewards: DailyRewardModel[]): DailyBonusesCardItem[] =>
  dailyRewards.map((reward) => ({
    id: reward.id,
    label: `День ${reward.day}`,
  }));
